/* CHS v2 collection page (sections/chs2-collection): client-side sort and need filter.
   Each grid item carries data-rank (Best sellers position: 90-day units sold, ties by gross sales; set by build_coll.py),
   data-units, data-rating (x100, -1 = unrated or too few reviews), data-rc (review count), data-price (cents), data-i
   (collection order) and data-needs (need family keys). The server renders Best sellers.
   State is kept in the URL (?sort=rated|price&need=<key>) next to ?view=v2, so a shared link opens the same view; a value
   whose button is not on the page (Top rated hidden, a chip not offered here) is ignored and dropped from the URL.
   With a need chip on, each item's [data-cx-why] tag for that need shows why the product is listed.
   Rows: the grid is a shared .c2-pgrid, so chs2.js levels its card rows (the Subscribe & Save line takes its row's
   height) on load, when fonts arrive and when the width changes. After a sort or a filter this script asks it again
   with window.CHS2.level(grid): the rows have changed. */
(function () {
  'use strict';
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var reduced = false;
  try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  // keep a pressed chip in view inside its own row when that row scrolls sideways; never moves the page
  function reveal(btn) {
    var row = btn && btn.parentElement;
    if (!row || row.scrollWidth <= row.clientWidth + 1) return;
    var b = btn.getBoundingClientRect(), r = row.getBoundingClientRect();
    if (b.left < r.left || b.right > r.right) row.scrollLeft += b.left - r.left - 16;
  }

  // the shared row levelling (chs2.js); it skips hidden items, so a filtered grid levels only what shows
  function level(grid) { if (window.CHS2 && window.CHS2.level) window.CHS2.level(grid); }

  function Coll(root) {
    var grid = root.querySelector('[data-cx-grid]');
    if (!grid) return;
    var items = qa('[data-cx-it]', grid), total = items.length;
    var nEl = root.querySelector('[data-cx-n]'), ofEl = root.querySelector('[data-cx-of]');
    var st = { sort: 'best', need: '' };
    function num(el, k) { var v = parseFloat(el.getAttribute('data-' + k)); return isNaN(v) ? 0 : v; }
    function cmp(how) {
      return function (a, b) {
        var d = 0;
        if (how === 'rated') d = (num(b, 'rating') - num(a, 'rating')) || (num(b, 'rc') - num(a, 'rc'));
        else if (how === 'price') d = num(a, 'price') - num(b, 'price');
        return d || (num(a, 'rank') - num(b, 'rank')) || (num(a, 'i') - num(b, 'i'));
      };
    }
    function has(el, need) { return !need || (' ' + (el.getAttribute('data-needs') || '') + ' ').indexOf(' ' + need + ' ') > -1; }
    function apply(animate) {
      items.slice().sort(cmp(st.sort)).forEach(function (el) { grid.appendChild(el); });
      var shown = 0;
      items.forEach(function (el) { var ok = has(el, st.need); el.hidden = !ok; if (ok) shown++; });
      qa('[data-cx-why]', grid).forEach(function (t) { t.hidden = !st.need || t.getAttribute('data-cx-why') !== st.need; });
      if (nEl) nEl.textContent = String(shown);
      if (ofEl) ofEl.hidden = shown === total;
      qa('[data-cx-sort]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-cx-sort') === st.sort)); });
      qa('[data-cx-need]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-cx-need') === st.need)); });
      reveal(root.querySelector('[data-cx-need][aria-pressed="true"]'));
      level(grid);
      if (animate && !reduced) { grid.classList.remove('is-swap'); void grid.offsetWidth; grid.classList.add('is-swap'); }
      try {
        var u = new URL(window.location.href);
        if (st.sort !== 'best') u.searchParams.set('sort', st.sort); else u.searchParams.delete('sort');
        if (st.need) u.searchParams.set('need', st.need); else u.searchParams.delete('need');
        window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cx-sort]');
      if (b) { if (b.getAttribute('data-cx-sort') !== st.sort) { st.sort = b.getAttribute('data-cx-sort'); apply(true); } return; }
      b = e.target.closest('[data-cx-need]');
      if (b) { if (b.getAttribute('data-cx-need') !== st.need) { st.need = b.getAttribute('data-cx-need'); apply(true); } }
    });
    var asked = false;
    try {
      var q = new URLSearchParams(window.location.search);
      var s = (q.get('sort') || '').replace(/[^a-z-]/g, ''), n = (q.get('need') || '').replace(/[^a-z-]/g, '');
      asked = q.has('sort') || q.has('need');
      if (s && root.querySelector('[data-cx-sort="' + s + '"]')) st.sort = s;
      if (n && root.querySelector('[data-cx-need="' + n + '"]')) st.need = n;
    } catch (e) {}
    if (asked) apply(false);
  }

  function boot() { qa('[data-cx-page]').forEach(Coll); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
